import {
    AfterViewInit,
    Component,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { CostCenter } from '../../contract-cumulative/CostCenter';
import { Users } from '../../contract-cumulative/store/users.model';
import { Contract } from '../../data-services';
import { ManualAdjustment } from '../../data-services/manual-adjustment';
import { RecalculateSetting } from '../../data-services/recalculate-transactions/recalculate-settings/recalculate-settings.model';
import * as fromLookups from '../../lookups';
import { CalcType, IServiceItem, ITask, IUserGroup } from '../../lookups';
import { PayrollItem } from '../../payroll/item';
import { IStatusMessage, Process, SelectItem, Table } from '../../shared';
import { columnResize } from '../../shared/columnResize';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-manual-adjustment-presenter',
    templateUrl: './manual-adjustment-presenter.component.html',
    styleUrls: ['./manual-adjustment-presenter.component.scss'],
    standalone: false
})
export class ManualAdjustmentPresenterComponent
    extends DisplayErrors<ManualAdjustment>
    implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
    IsColumnFrozen = false;
    elements: HTMLCollection;
    SelectedErrorSubject = new ReplaySubject<IStatusMessage>(1);
    startDate: any;
    endDate: any;
    companyFYNotice: any[];
    colspan = 6;
    private AdjustmentsSubject = new ReplaySubject<Array<ManualAdjustment>>(1);
    private _adjustments: Array<any>;
    txnNote: any;
    asOfDate: any;
    @Input() set adjustments(value: Array<ManualAdjustment>) {
        // this._adjustments = value;
        this._adjustments = value.map(x => ({
            Txnid: x.Txnid,
            Sessionid: x.Sessionid,
            Billablestatus: x.Billablestatus,
            Txntype: x.Txntype,
            TxnTypeName: this.findTxnType(x.Txntype),
            Txndate: x.Txndate,
            TxnNotes: x.TxnNotes,
            Modifieddate: x.Modifieddate,
            Createdate: x.Createdate,
            Adjustmentstatus: x.Adjustmentstatus,
            Contractlistid: x.Contractlistid,
            Contractdesc: x.Contractdesc,
            Tasklistid: x.Tasklistid,
            TaskName: this.findTask(x),
            Employeelistid: x.Employeelistid,
            EmployeeName: this.findEmployee(x),
            Pilistid: x.Pilistid,
            PayrollItem: this.findPayrollItem(x),
            Silistid: x.Silistid,
            ServiceItem: this.findServiceItem(x),
            Costcenterid: x.Costcenterid,
            CostCenter: this.findCostCenterName(x.Costcenterid),
            Hoursworked: x.Hoursworked,
            Invoiceamount: x.Invoiceamount,
            InvoiceLabor: x.InvoiceLabor,
            Gacost: x.Gacost,
            Mhcost: x.Mhcost,
            Ohcost: x.Ohcost,
            Frcost: x.Frcost,
            Feecost: x.Feecost,
            Actualamount: x.Actualamount,
            IncurredLabor: x.IncurredLabor,
            Gacostebr: x.Gacostebr,
            Mhcostebr: x.Mhcostebr,
            Ohcostebr: x.Ohcostebr,
            Frcostebr: x.Frcostebr,
            Feecostebr: x.Feecostebr,
            Autocalculate: x.Autocalculate,
            Autoburden: x.Autoburden,
            Status: x.Status,
            id: x.id,
            original: x.original,
            Row_Version: x.Row_Version
        }));
        this.AdjustmentsSubject.next(this._adjustments);

        this.txnTypesFilterSelectItem = value.map(x => ({
            value: x.Txnid,
            label: this.findTxnType(x.Txntype)
        }));
        this.txnTypesFilterSelectItem = this.txnTypesFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );

        this.userGroupsFilterSelectItem = value.map(x => ({
            value: x.Costcenterid,
            label: this.findCostCenterName(x.Costcenterid)
        }));
        this.userGroupsFilterSelectItem =
            this.userGroupsFilterSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );

        this.tasksFilterSelectItem = value.map(x => ({
            value: x.Tasklistid,
            label: this.findTask(x)
        }));
        this.tasksFilterSelectItem = this.tasksFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );

        this.contractsFilterSelectItem = value.map(x => ({
            value: x.Contractlistid,
            label: x.Contractdesc
        }));
        this.contractsFilterSelectItem = this.contractsFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );

        this.directReportsFilterSelectItem = value.map(x => ({
            value: x.Employeelistid,
            label: this.findEmployee(x)
        }));
        this.directReportsFilterSelectItem =
            this.directReportsFilterSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );

        this.serviceItemsFilterSelectItem = value.map(x => ({
            value: x.Silistid,
            label: this.findServiceItem(x)
        }));
        this.serviceItemsFilterSelectItem =
            this.serviceItemsFilterSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );

        this.payrollItemsFilterSelectItem = value.map(x => ({
            value: x.Pilistid,
            label: this.findPayrollItem(x)
        }));
        this.payrollItemsFilterSelectItem =
            this.payrollItemsFilterSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );

        this.IsLoading = false;
    }
    get adjustments(): Array<ManualAdjustment> {
        return this._adjustments;
    }

    private TasksSubject = new ReplaySubject<Array<ITask>>(1);
    private _tasks: Array<ITask>;
    @Input() set tasks(value: Array<ITask>) {
        if (value) {
            this._tasks = value;
            const filteredTasks = this._tasks.filter(
                x => x.ContractType != 'LOC'
            );
            this.TasksSubject.next(value);
            this.tasksSelectItem = filteredTasks.map(x => ({
                value: x.TaskListID,
                label: x.TaskLongName
            }));
            this.tasksInTableSelectItem = filteredTasks.map(x => ({
                value: x.TaskListID,
                label: x.TaskLongName
            }));
        }
    }
    get tasks(): Array<ITask> {
        return this._tasks;
    }

    private DirectReportsSubject = new ReplaySubject<Array<Partial<Users>>>(1);
    private _directreports: Array<Partial<Users>>;
    @Input() set directreports(value: Array<Partial<Users>>) {
        if (value) {
            value.splice(0, 0, {
                EmployeeListID: 'SYS000000000000000000000000000000000',
                EmployeeName: 'Not applicable'
            });
            this._directreports = value;
            this.DirectReportsSubject.next(value);
            this.directReportsSelectItem = this._directreports
            .filter(x => x.IsActive == true)
            .map(x => ({
                value: x.EmployeeListID,
                label: x.EmployeeName
            }));
        }
    }
    get directreports(): Array<Partial<Users>> {
        return this._directreports;
    }

    private ServiceItemsSubject = new ReplaySubject<Array<IServiceItem>>(1);
    private _serviceitems: Array<IServiceItem>;
    @Input() set serviceitems(value: Array<IServiceItem>) {
        if (value) {
            this._serviceitems = value;
            this.ServiceItemsSubject.next(value);
            this.serviceItemsSelectItem = this._serviceitems.map(x => ({
                value: x.SIListID,
                label: x.ServiceItem
            }));
            this.log.verbose('si count = ' + this._serviceitems.length);
        }
    }
    get serviceitems(): Array<IServiceItem> {
        return this._serviceitems;
    }

    private PayrollItemsSubject = new ReplaySubject<Array<PayrollItem>>(1);
    private _payrollitems: Array<PayrollItem>;
    @Input() set payrollitems(value: Array<PayrollItem>) {
        if (value) {
            this._payrollitems = value;
            this.PayrollItemsSubject.next(value);
            this.payrollItemsSelectItem = this._payrollitems.map(x => ({
                value: x.PIListID,
                label: x.PayrollItem
            }));
            this.log.verbose('pi count = ' + this._payrollitems.length);
        }
    }
    get payrollitems(): Array<PayrollItem> {
        return this._payrollitems;
    }

    private SEItemsSubject = new ReplaySubject<Array<Item>>(1);
    private _seitems: Array<Item>;
    @Input() set seitems(value: Array<Item>) {
        if (value) {
            this._seitems = value;
            this.SEItemsSubject.next(value);
            this.serviceItemsSelectItem = this._seitems.map(x => ({
                value: x.IListID,
                label: x.Item
            }));
            this.log.verbose('i count = ' + this._seitems.length);
        }
    }
    get seitems(): Array<Item> {
        return this._seitems;
    }

    private ContractsSubject = new ReplaySubject<Array<Contract.Contract>>(1);
    private _contracts: Array<Contract.Contract>;
    @Input() set contracts(value: Array<Contract.Contract>) {
        if (value) {
            this._contracts = value;
            this.ContractsSubject.next(value);
        }
    }
    get contracts(): Array<Contract.Contract> {
        return this._contracts;
    }

    private TxnTypesSubject = new ReplaySubject<Array<CalcType>>(1);
    private _txntypes: Array<CalcType>;
    @Input() set txntypes(value: Array<CalcType>) {
        if (value) {
            this._txntypes = value;
            this.TxnTypesSubject.next(value);
            // this.txnTypesSelectItem = filteredTxnTypes.map(x => ({
            //     value: x.CalcType,
            //     label: x.CalcDesc
            // }));
        }
    }
    get txntypes(): Array<CalcType> {
        return this._txntypes;
    }

    private CompanySettingsSubject = new ReplaySubject<
        Array<RecalculateSetting>
    >(1);
    private _companysettings: Array<RecalculateSetting>;
    @Input() set companysettings(value: Array<RecalculateSetting>) {
        if (value) {
            this._companysettings = value;
            this.CompanySettingsSubject.next(this._companysettings);
            const fyyear = moment(this._companysettings[0].SettingValue).year();
            this.CSFYStart = moment(
                this._companysettings[0].SettingValue
            ).toDate();
            this.CSFYEnd = moment(`12/31/${fyyear}`).toDate();
            this.companyFYNotice = [
                {
                    severity: 'info',
                    summary: '',
                    detail: `Company Fiscal Year set to ${moment(
                        this.CSFYStart
                    ).format('MM/DD/YYYY')} - ${moment(this.CSFYEnd).format(
                        'MM/DD/YYYY'
                    )}`
                }
            ];
        }
    }
    get companysettings(): Array<RecalculateSetting> {
        return this._companysettings;
    }

    @Input() public userGroups: Array<fromLookups.IUserGroup>;

    @Input() public process: Process;

    @Input() public userInfo: IUserInfo;

    @Output() SaveAdjustment = new ReplaySubject<ManualAdjustment>(1);
    @Output() LoadAdjustments = new ReplaySubject<any>(1);
    @Output() AddAdjustments = new ReplaySubject<any>(1);
    @Output() DeleteAdjustment = new ReplaySubject<ManualAdjustment>(1);
    @Output() LoadLaborOrExpense = new ReplaySubject<any>(1);
    public editing?: ManualAdjustment = {} as ManualAdjustment;
    clonedAdjustments: { [i: string]: ManualAdjustment } = {};
    active = true;
    public moment: any;
    tableScrollHeight = '50em';
    addFormGroup: UntypedFormGroup;
    ccFormGroup: UntypedFormGroup;
    taskFormGroup: UntypedFormGroup;
    siFormGroup: UntypedFormGroup;
    piFormGroup: UntypedFormGroup;
    contractFormGroup: UntypedFormGroup;
    empFormGroup: UntypedFormGroup;
    filterFormGroup: UntypedFormGroup;
    typeFormGroup: UntypedFormGroup;
    doi = 'Direct';
    txnTypesSelectItem: SelectItem[] = [];
    txnTypesInTableSelectItem: SelectItem[] = [];
    userGroupsSelectItem: SelectItem[] = [];
    userGroupsInTableSelectItem: SelectItem[] = [];
    tasksSelectItem: SelectItem[] = [];
    tasksInTableSelectItem: SelectItem[] = [];
    @Input() contractsSelectItem: SelectItem[];
    directReportsSelectItem: SelectItem[] = [];
    directReportsInTableSelectItem: SelectItem[] = [];
    serviceItemsSelectItem: SelectItem[] = [];
    payrollItemsSelectItem: SelectItem[] = [];
    sessionDatesSelectItem: SelectItem[] = [];
    billableStatusSelectItem: SelectItem[] = [];

    txnTypesFilterSelectItem: SelectItem[] = [];
    userGroupsFilterSelectItem: SelectItem[] = [];
    tasksFilterSelectItem: SelectItem[] = [];
    contractsFilterSelectItem: SelectItem[] = [];
    directReportsFilterSelectItem: SelectItem[] = [];
    serviceItemsFilterSelectItem: SelectItem[] = [];
    payrollItemsFilterSelectItem: SelectItem[] = [];

    siHidden = false;
    siColumnHidden = false;
    empHidden = false;
    empColumnHidden = false;
    selectedContracts: Contract.Contract[] = [];
    selectedDirectReports: Users[] = [];
    selectedServiceItems: IServiceItem[] = [];
    selectedPayrollItems: PayrollItem[] = [];
    selectedTasks: ITask[] = [];
    selectedCCs: IUserGroup[] = [];
    costCenters: CostCenter[] = [];

    IsLoading = false;

    IsDirectAdd = true;
    IsIndirectAdd = false;

    IsDirectFilter = true;
    IsIndirectFilter = false;

    selectedContract: Contract.Contract;

    asOfDateValid = false;
    contractValid = false;
    directReportValid = false;
    serviceItemValid = false;
    txnTypeValid = false;
    taskValid = false;
    ccValid = false;

    asOfDateIsRequired = false;
    contractIsRequired = false;
    directReportIsRequired = false;
    serviceItemIsRequired = false;
    txnTypeIsRequired = false;
    taskIsRequired = false;
    ccIsRequired = false;

    currentPayPeriodStart: any;
    currentPayPeriodEnd: any;
    prevPayPeriodStart: any;
    prevPayPeriodEnd: any;

    SIColumnHidden = false;
    PIColumnHidden = false;
    EmpColumnHidden = false;
    BillableColumnHidden = false;
    CCColumnHidden = false;

    length: number;
    header: string;

    manualAdjustmentsTabHeader = 'Manual Adjustments';

    @ViewChild(Table, { static: true })
    adjTable: Table;

    colsCanBeHidden: any[];
    cols: any[];
    frozenCols: any[];

    CSFYStart: Date;
    CSFYEnd: Date;

    _selectedColumns: any[];
    @Input() get selectedColumns(): any[] {
        return this._selectedColumns;
    }

    set selectedColumns(val: any[]) {
        // restore original order
        this._selectedColumns = this.colsCanBeHidden.filter(col =>
            val.includes(col)
        );
    }
    showDialog = false;
    calcFormGroup: UntypedFormGroup;
    autoCalculate = false;
    autoBurden = false;
    includeInactive = false;

    constructor(@Inject(LoggingService) private log: LoggingService) {
        super();
        this.moment = moment;
        this.calcFormGroup = new UntypedFormGroup({
            CalculateAmount: new UntypedFormControl(null),
            CalculateBurden: new UntypedFormControl(null)
        });
        this.addFormGroup = new UntypedFormGroup({
            Asofdate: new UntypedFormControl(null),
            Contracts: new UntypedFormControl(null),
            Txntypes: new UntypedFormControl(null),
            Tasks: new UntypedFormControl(null),
            PayrollItems: new UntypedFormControl(null),
            Items: new UntypedFormControl(null),
            DirectReports: new UntypedFormControl(null),
            CC: new UntypedFormControl(null),
            direct: new UntypedFormControl(null),
            indirect: new UntypedFormControl(null),
            note: new UntypedFormControl(null)
        });

        this.filterFormGroup = new UntypedFormGroup({
            Range: new UntypedFormControl(null),
            direct: new UntypedFormControl(null),
            indirect: new UntypedFormControl(null),
            Contracts: new UntypedFormControl(null)
        });

        this.ccFormGroup = new UntypedFormGroup({
            CC: new UntypedFormControl(null)
        });

        this.taskFormGroup = new UntypedFormGroup({
            Task: new UntypedFormControl(null)
        });

        this.siFormGroup = new UntypedFormGroup({
            SI: new UntypedFormControl(null)
        });

        this.empFormGroup = new UntypedFormGroup({
            Emp: new UntypedFormControl(null)
        });

        this.typeFormGroup = new UntypedFormGroup({
            Type: new UntypedFormControl(null)
        });

        this.piFormGroup = new UntypedFormGroup({
            pi: new UntypedFormControl(null)
        });

        this.contractFormGroup = new UntypedFormGroup({
            Contracts: new UntypedFormControl(null)
        });
    }

    ngOnInit() {
        this.billableStatusSelectItem = [
            {
                label: 'Billable',
                value: 'Billable'
            },
            {
                label: 'NotBillable',
                value: 'NotBillable'
            }
        ];
        this.log.verbose({ type: 'cs: ', CSFYStart: this.CSFYStart });
        this.log.verbose({ type: 'cs: ', CSFYEnd: this.CSFYEnd });

        this.manualAdjustmentsTabHeader = `Manual Adjustments for ${moment(
            this.startDate
        ).format('MM/DD/YYYY')} - ${moment(this.endDate).format('MM/DD/YYYY')}`;

        this.cols = [
            { field: 'Adjustmentstatus', header: 'Status' },
            { field: 'Txndate', header: 'Txn Date' },
            { field: 'TxnTypeName', header: 'Txn Type' },
            { field: 'TaskName', header: 'Task' },
            { field: 'EmployeeName', header: 'Person' },
            { field: 'ServiceItem', header: 'Item' },
            { field: 'PayrollItem', header: 'Payroll Item' },
            { field: 'CostCenter', header: 'Cost Center' },
            { field: 'Billablestatus', header: 'Billable Status' },
            { field: 'Hoursworked', header: 'Hours' },
            { field: 'Invoiceamount', header: 'Invoiced Amount' },
            { field: 'Gacost', header: 'G&A Invoiced' },
            { field: 'Mhcost', header: 'MH Invoiced' },
            { field: 'Ohcost', header: 'OH Invoiced' },
            { field: 'Frcost', header: 'FR Invoiced' },
            { field: 'Feecost', header: 'Fee Invoiced' },
            { field: 'Actualamount', header: 'Incurred Amount' },
            { field: 'Gacostebr', header: 'G&A Incurred' },
            { field: 'Mhcostebr', header: 'MH Incurred' },
            { field: 'Ohcostebr', header: 'OH Incurred' },
            { field: 'Frcostebr', header: 'FR Incurred' },
            { field: 'Feecostebr', header: 'Fee Incurred' },
            { field: 'TxnNotes', header: 'Notes' }
        ];

        this.colsCanBeHidden = [
            { field: 'Employeelistid', header: 'Person' },
            { field: 'Silistid', header: 'Item' },
            { field: 'Pilistid', header: 'Payroll Item' },
            { field: 'Costcenterid', header: 'Cost Center' },
            { field: 'Billablestatus', header: 'Billable Status' }
        ];

        this._selectedColumns = this.colsCanBeHidden;

        this.setupObservables();
        this.setupSubscriptions();
        if (this.userInfo) {
            this.currentPayPeriodStart = this.userInfo.CurrentPayPeriodStart;
            this.currentPayPeriodEnd = this.userInfo.CurrentPayPeriodEnd;
            this.prevPayPeriodStart = this.userInfo.PrevPayPeriodStart;
            this.prevPayPeriodEnd = this.userInfo.PrevPayPeriodEnd;
            this.filterFormGroup.controls['Range'].patchValue([
                this.prevPayPeriodStart,
                this.prevPayPeriodEnd
            ]);
        }
        this.filterFormGroup.controls['direct'].patchValue('direct');

        setTimeout(() => {
            this.elements = document.getElementsByClassName('p-header-cell');
        }, 0);
    }

    ngAfterViewInit(): void {
        this.IsColumnFrozen = true;
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (changes.userInfo && changes.userInfo.currentValue) {
            this.startDate = this.userInfo.CurrentPayPeriodStart;
            this.endDate = this.userInfo.CurrentPayPeriodEnd;
            if (!this.CSFYStart && this.userInfo.FYStartDate) {
                this.CSFYStart = this.userInfo.FYStartDate;
            }
            if (!this.CSFYEnd && this.userInfo.FYEndDate) {
                this.CSFYEnd = this.userInfo.FYEndDate;
            }
            const rangeControl = this.filterFormGroup?.controls['Range'];
            const currentRange = rangeControl?.value;
            if (
                rangeControl &&
                (!currentRange ||
                    !Array.isArray(currentRange) ||
                    currentRange.length < 2)
            ) {
                rangeControl.patchValue(
                    [
                        this.userInfo.PrevPayPeriodStart,
                        this.userInfo.PrevPayPeriodEnd
                    ],
                    { emitEvent: false }
                );
            }
        }
        if (
            changes.userGroups &&
            changes.userGroups.currentValue &&
            changes.userGroups.currentValue.length > 0
        ) {
            this.userGroups = this.userGroups.filter(x =>
                x.PrefixedGroupID.includes('C')
            );
            this.userGroupsSelectItem = this.userGroups.map(x => ({
                label: x.GroupName,
                value: x.GroupID
            }));
            this.userGroupsInTableSelectItem = this.userGroups.map(x => ({
                label: x.GroupName,
                value: x.GroupID
            }));

            const ccControl = this.addFormGroup.controls['CC'];
            if (this.userGroups.length > 1) {
                ccControl.setValidators([Validators.required]);
            } else {
                ccControl.clearValidators();
                this.ccValid = true;
                this.ccIsRequired = false;
            }
            ccControl.updateValueAndValidity();
        }
    }
    ngOnDestroy() {
        this.active = false;
    }

    includeInactiveChanged(event) {
        this.includeInactive = event.checked;
        if (event.checked == true) {
            this.directReportsSelectItem = this.directreports
                .filter(x => x.IsActive == false || x.IsActive == true)
                .map(x => ({
                    label: x.EmployeeName,
                    value: x.EmployeeListID
                }));
        } else {
            this.directReportsSelectItem = this.directreports
                .filter(x => x.IsActive == true)
                .map(x => ({
                    label: x.EmployeeName,
                    value: x.EmployeeListID
                }));
        }
    }

    onColumnResize($event) {
        var table = document.querySelector('table');
        columnResize($event, 6, table);
        // var numOfFrozenCols = 6;
        // var colIndex = $event.element.cellIndex + 1;
        // var change = $event.delta;

        // //fit
        // if (colIndex < numOfFrozenCols) {
        //     var columnTdCells = Array.from(document.querySelectorAll(`td:nth-child(${colIndex})`)) as Array<any>;
        //     for (var y = 0; y < columnTdCells.length; y++) {
        //         var style = getComputedStyle(columnTdCells[y].nextSibling);
        //         var left = style.getPropertyValue("left");
        //         var leftArr = left.split("p");
        //         var leftValue = leftArr[0];
        //         var newLeftValue;

        //         newLeftValue = +leftValue + change;
        //         columnTdCells[y].nextSibling.style.left = `${newLeftValue}px`;

        //     }
        //     var columnThCells = Array.from(document.querySelectorAll(`th:nth-child(${colIndex})`)) as Array<any>;
        //     for (var z = 0; z < columnThCells.length; z++) {
        //         var style = getComputedStyle(columnThCells[z].nextSibling);
        //         var left = style.getPropertyValue("left");
        //         var leftArr = left.split("p");
        //         var leftValue = leftArr[0];
        //         var newLeftValue;

        //         newLeftValue = +leftValue + change;
        //         columnThCells[z].nextSibling.style.left = `${newLeftValue}px`;

        //     }
        // }

        // //$event.element.nextSibling.style.left = `${newLeftValue}px`;
        // this.log.verbose($event);
    }

    openDialog() {
        this.addFormGroup.controls['direct'].patchValue('direct');
        this.addFormGroup.controls['indirect'].patchValue(null);
        this.showDialog = true;
    }

    addManualAdj() {
        this.buildTable();
    }

    closeDialog() {
        this.showDialog = false;
    }

    setupObservables() {
        this.log.verbose({
            type: 'ManualAdjustmentPresenterComponent:setupObservables'
        });
    }

    setupSubscriptions() {
        this.log.verbose({
            type: 'ManualAdjustmentPresenterComponent:setupSubscriptions'
        });

        this.calcFormGroup.controls['CalculateAmount'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.autoCalculate = value;
            });
        this.calcFormGroup.controls['CalculateBurden'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.autoBurden = value;
            });

        this.filterFormGroup.controls['direct'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.filterFormGroup.controls['indirect'].patchValue(null);
                    this.filterFormGroup.controls['Contracts'].reset();
                    this.adjTable.clear();
                    this.IsIndirectFilter = false;
                    this.IsDirectFilter = true;
                    let filteredTxnTypes;
                    let filteredContracts;
                    let filteredTasks;
                    this.doi = 'Direct';
                    if (this.txntypes) {
                        filteredTxnTypes = this.txntypes.filter(
                            x => x.CostType == 'Direct'
                        );
                    }

                    if (this.contracts) {
                        filteredContracts = this.contracts.filter(
                            x => x.ContractType == 'LOC'
                        );
                    }

                    if (this.tasks) {
                        filteredTasks = this.tasks.filter(
                            x => x.ContractType == 'LOC'
                        );
                    }

                    this.LoadAdjustments.next({
                        DirectOrIndirect: this.doi,
                        StartDate: this.startDate, // this.userInfo.CurrentPayPeriodStart,
                        EndDate: this.endDate // this.userInfo.CurrentPayPeriodEnd
                    });
                }
            });
        this.filterFormGroup.controls['indirect'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.filterFormGroup.controls['direct'].patchValue(null);
                    this.filterFormGroup.controls['Contracts'].reset();
                    this.adjTable.clear();
                    this.IsIndirectFilter = true;
                    this.IsDirectFilter = false;

                    let filteredTxnTypes;
                    let filteredContracts;
                    let filteredTasks;

                    this.doi = 'Indirect';
                    if (this.txntypes) {
                        filteredTxnTypes = this.txntypes.filter(
                            x => x.CostType == 'Indirect'
                        );
                    }

                    if (this.contracts) {
                        filteredContracts = this.contracts.filter(
                            x => x.ContractType == 'LOC'
                        );
                    }

                    if (this.tasks) {
                        filteredTasks = this.tasks.filter(
                            x => x.ContractType == 'LOC'
                        );
                    }

                    this.LoadAdjustments.next({
                        DirectOrIndirect: this.doi,
                        StartDate: this.startDate, // this.userInfo.CurrentPayPeriodStart,
                        EndDate: this.endDate // this.userInfo.CurrentPayPeriodEnd
                    });
                }
            });

        this.filterFormGroup.controls['Range'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (value[0] && value[1]) {
                        this.startDate = value[0];
                        this.endDate = value[1];
                        if (this.asOfDate != null) {
                            if (
                                this.asOfDate <= value[1] &&
                                this.asOfDate >= value[0]
                            ) {
                                // as of date is within the current date range
                            } else {
                                const POSTData: any = {
                                    DirectOrIndirect: this.doi,
                                    StartDate: moment(value[0]).format(
                                        'MM/DD/YYYY'
                                    ),
                                    EndDate: moment(value[1]).format(
                                        'MM/DD/YYYY'
                                    )
                                };
                                this.LoadAdjustments.next(POSTData);
                            }
                        } else {
                            const POSTData: any = {
                                DirectOrIndirect: this.doi,
                                StartDate: moment(value[0]).format(
                                    'MM/DD/YYYY'
                                ),
                                EndDate: moment(value[1]).format('MM/DD/YYYY')
                            };
                            this.LoadAdjustments.next(POSTData);
                        }

                        this.manualAdjustmentsTabHeader = `Manual Adjustments for ${moment(
                            this.startDate
                        ).format('MM/DD/YYYY')} - ${moment(this.endDate).format(
                            'MM/DD/YYYY'
                        )}`;
                    }
                }
            });
        this.filterFormGroup.controls['Contracts'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (value) {
                        const contractids: string[] = [];
                        value.forEach(val => {
                            contractids.push(
                                (
                                    this.contracts.find(
                                        x => x.ContractListID == val
                                    ) as Contract.Contract
                                )?.ContractDesc
                            );
                        });
                        this.adjTable.filter(contractids, 'Contractdesc', 'in');
                        // this.selectedContracts = [];
                        // value.forEach(val => {
                        //     this.selectedContracts.push(
                        //         this.contracts.find(x => x.ContractListID == val)
                        //     );
                        // });
                        // if (this.startDate && this.endDate) {
                        //     let POSTData: any = {
                        //         DirectOrIndirect: this.doi,
                        //         StartDate: moment(this.startDate).format('MM/DD/YYYY'),
                        //         EndDate: moment(this.endDate).format('MM/DD/YYYY'),
                        //         Contracts: this.selectedContracts
                        //     };
                        //     this.LoadAdjustments.next(POSTData);
                        // } else {
                        //     let POSTData: any = {
                        //         DirectOrIndirect: this.doi,
                        //         StartDate: moment(this.userInfo.CurrentPayPeriodStart).format('MM/DD/YYYY'),
                        //         EndDate: moment(this.userInfo.CurrentPayPeriodEnd).format('MM/DD/YYYY'),
                        //         Contracts: this.selectedContracts
                        //     };
                        //     this.LoadAdjustments.next(POSTData);
                        // }
                    }
                }
            });

        this.addFormGroup.controls['direct'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.addFormGroup.controls['indirect'].patchValue(null);
                    this.addFormGroup.controls['Contracts'].reset();
                    this.addFormGroup.controls['Tasks'].reset();
                    this.addFormGroup.controls['Txntypes'].reset();
                    this.addFormGroup.controls['CC'].reset();
                    this.addFormGroup.controls['Items'].reset();
                    this.addFormGroup.controls['PayrollItems'].reset();
                    this.addFormGroup.controls['DirectReports'].reset();

                    let filteredTxnTypes;
                    let filteredContracts;
                    let filteredTasks;

                    this.doi = 'Direct';
                    filteredTxnTypes = this.txntypes.filter(
                        x => x.CostType == 'Direct' && x.CalcType != 'FP'
                    );
                    filteredContracts = this.contracts.filter(
                        x => x.ContractType != 'LOC' && x.IsActive == true
                    );
                    filteredTasks = this.tasks.filter(
                        x => x.ContractType != 'LOC'
                    );

                    this.contractsSelectItem = filteredContracts.map(x => ({
                        value: x.ContractListID,
                        label: x.ContractDesc
                    }));
                    this.tasksSelectItem = filteredTasks.map(x => ({
                        value: x.TaskListID,
                        label: x.TaskLongName
                    }));
                    this.tasksInTableSelectItem = filteredTasks.map(x => ({
                        value: x.TaskListID,
                        label: x.TaskLongName
                    }));
                    this.txnTypesSelectItem = filteredTxnTypes.map(x => ({
                        value: x.CalcType,
                        label: x.CalcDesc
                    }));

                    // this.txnTypesInTableSelectItem = filteredTxnTypes.map(x => ({
                    //     value: x.CalcType,
                    //     label: x.CalcDesc
                    // }));
                }
            });
        this.addFormGroup.controls['indirect'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.addFormGroup.controls['direct'].patchValue(null);
                    this.addFormGroup.controls['Contracts'].reset();
                    this.addFormGroup.controls['Tasks'].reset();
                    this.addFormGroup.controls['Txntypes'].reset();
                    this.addFormGroup.controls['CC'].reset();
                    this.addFormGroup.controls['Items'].reset();
                    this.addFormGroup.controls['PayrollItems'].reset();
                    this.addFormGroup.controls['DirectReports'].reset();

                    let filteredTxnTypes;
                    let filteredContracts;
                    let filteredTasks;

                    this.doi = 'Indirect';
                    filteredTxnTypes = this.txntypes.filter(
                        x =>
                            x.CostType == 'Indirect' && x.CostSubType == 'Labor' && x.CalcType != 'FP'
                    );
                    filteredContracts = this.contracts.filter(
                        x => x.ContractType == 'LOC' && x.IsActive == true
                    );
                    filteredTasks = this.tasks.filter(
                        x => x.ContractType == 'LOC'
                    );

                    this.contractsSelectItem = filteredContracts.map(x => ({
                        value: x.ContractListID,
                        label: x.ContractDesc
                    }));
                    this.tasksSelectItem = filteredTasks.map(x => ({
                        value: x.TaskListID,
                        label: x.TaskLongName
                    }));
                    this.tasksInTableSelectItem = filteredTasks.map(x => ({
                        value: x.TaskListID,
                        label: x.TaskLongName
                    }));
                    this.txnTypesSelectItem = filteredTxnTypes.map(x => ({
                        value: x.CalcType,
                        label: x.CalcDesc
                    }));
                    // this.txnTypesInTableSelectItem = filteredTxnTypes.map(x => ({
                    //     value: x.CalcType,
                    //     label: x.CalcDesc
                    // }));
                }
            });
        this.addFormGroup.controls['Asofdate'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    // this.selectedAsOfDate = value;
                    this.asOfDate = value;
                    this.asOfDateValid = true;
                    this.asOfDateIsRequired = false;
                    if (value <= this.endDate && value >= this.startDate) {
                        // value is within start and end dates
                    } else {
                        if (value > this.startDate) {
                            // this.filterFormGroup.controls['Range'].patchValue([
                            //     this.startDate,
                            //     value
                            // ]);
                            this.endDate = value;
                        }
                        if (value < this.startDate) {
                            this.filterFormGroup.controls['Range'].patchValue([
                                value,
                                this.endDate
                            ]);
                            this.startDate = value;
                        }
                    }
                }
            });
        this.addFormGroup.controls['Contracts'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.addFormGroup.controls['Tasks'].reset();
                    this.contractIsRequired = false;
                    this.contractValid = true;
                    this.selectedContract = this.contracts.find(
                        x => x.ContractListID == value
                    ) as Contract.Contract;
                    const filteredTasks = this.tasks.filter(x =>
                        x.TaskLongName.includes(
                            this.selectedContract.ContractDesc
                        )
                    );
                    this.tasksSelectItem = filteredTasks.map(x => ({
                        value: x.TaskListID,
                        label: x.TaskLongName
                    }));
                }
            });
        this.addFormGroup.controls['Tasks'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.selectedTasks = [];
                    this.taskValid = true;
                    this.taskIsRequired = false;
                    value.forEach(val => {
                        this.selectedTasks.push(
                            this.tasks.find(
                                x => x.TaskListID == val
                            ) as fromLookups.ITask
                        );
                    });
                }
            });
        this.addFormGroup.controls['Txntypes'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.txnTypeValid = true;
                    this.txnTypeIsRequired = false;
                    const type = this.txntypes.find(
                        x => x.CalcType == value
                    ) as fromLookups.CalcType;
                    if (
                        value == 'T' ||
                        value == 'ODC' ||
                        value == 'MAT' ||
                        type.CostSubType == 'Expense'
                    ) {
                        this.siHidden = true;
                        this.empHidden = true;
                        this.serviceItemValid = true;
                        this.directReportValid = true;
                        // this.serviceItemIsRequired = false;
                        // this.directReportIsRequired = false;
                    }
                    if (value == 'SUB' || value == 'CON') {
                        this.siHidden = false;
                        this.empHidden = true;
                        this.directReportValid = true;
                        this.serviceItemValid = false;
                        // this.serviceItemIsRequired = true;
                        // this.directReportIsRequired = false;
                    }
                    if (type.CostSubType == 'Labor') {
                        this.siHidden = false;
                        this.empHidden = false;
                        this.directReportValid = false;
                        this.serviceItemValid = false;
                        // this.serviceItemIsRequired = true;
                        // this.directReportIsRequired = true;
                    }
                }
            });
        this.addFormGroup.controls['CC'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.selectedCCs = [];
                    this.ccValid = true;
                    this.ccIsRequired = false;
                    value.forEach(val => {
                        this.selectedCCs.push(
                            this.userGroups.find(
                                x => x.GroupID == val
                            ) as fromLookups.IUserGroup
                        );
                    });
                }
            });
        this.addFormGroup.controls['Items'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.selectedServiceItems = [];
                    this.serviceItemValid = true;
                    this.serviceItemIsRequired = false;
                    value.forEach(val => {
                        this.selectedServiceItems.push(
                            this.serviceitems.find(
                                x => x.SIListID == val
                            ) as fromLookups.IServiceItem
                        );
                    });
                }
            });
        this.addFormGroup.controls['PayrollItems'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.selectedPayrollItems = [];
                    value.forEach(val => {
                        this.selectedPayrollItems.push(
                            this.payrollitems.find(
                                x => x.PIListID == val
                            ) as PayrollItem
                        );
                    });
                }
            });
        this.addFormGroup.controls['DirectReports'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.selectedDirectReports = [];
                    this.directReportValid = true;
                    this.directReportIsRequired = false;
                    value.forEach(val => {
                        this.selectedDirectReports.push(
                            this.directreports.find(
                                x => x.EmployeeListID == val
                            ) as Users
                        );
                    });
                }
            });
        this.addFormGroup.controls['note'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.txnNote = value;
                }
            });
    }

    findCostCenterName(Costcenterid: number): string | undefined {
        if (Costcenterid != null) {
            if (this.userGroups && this.userGroups.length > 0) {
                if (Costcenterid === 0) {
                    return '';
                } else {
                    const cc = this.userGroups.find(
                        x => x.GroupID === Costcenterid
                    );
                    return cc?.GroupName;
                }
            }
        } else {
            return '';
        }
    }

    findTask(rowData: ManualAdjustment): string | undefined {
        if (rowData.Tasklistid != null) {
            if (this.tasks && this.tasks.length > 0) {
                const index = this.tasks.findIndex(
                    x => x.TaskListID === rowData.Tasklistid
                );
                if (index !== -1) {
                    const task = this.tasks[index];
                    return task.TaskLongName;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findEmployee(rowData: ManualAdjustment): string | undefined {
        if (rowData.Employeelistid != null) {
            if (this.directreports && this.directreports.length > 0) {
                const index = this.directreports.findIndex(
                    x => x.EmployeeListID === rowData.Employeelistid
                );
                if (index !== -1) {
                    const directreport = this.directreports[index];
                    return directreport.EmployeeName;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findServiceItem(rowData: ManualAdjustment): string | undefined {
        if (rowData.Silistid != null) {
            if (this.serviceitems && this.serviceitems.length > 0) {
                const index = this.serviceitems.findIndex(
                    x => x.SIListID === rowData.Silistid
                );
                if (index !== -1) {
                    const serviceitem = this.serviceitems[index];
                    return serviceitem.ServiceItem;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findPayrollItem(rowData: ManualAdjustment): string | undefined {
        if (rowData.Pilistid != null) {
            if (this.payrollitems && this.payrollitems.length > 0) {
                const index = this.payrollitems.findIndex(
                    x => x.PIListID === rowData.Pilistid
                );
                if (index !== -1) {
                    const payrollitem = this.payrollitems[index];
                    return payrollitem.PayrollItem;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findTxnType(rowData: any): string | undefined {
        if (rowData != null) {
            if (this.txntypes && this.txntypes.length > 0) {
                const index = this.txntypes.findIndex(
                    x => x.CalcType === rowData
                );
                if (index !== -1) {
                    const txntype = this.txntypes[index];
                    return txntype.CalcDesc;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    filterTable($event, filterType) {
        // use this for all table filters
        if (filterType == 'si') {
            this.adjTable.filter($event.value, 'Silistid', 'in');
        } else if (filterType == 'pi') {
            this.adjTable.filter($event.value, 'Pilistid', 'in');
        } else if (filterType == 'task') {
            this.adjTable.filter($event.value, 'Tasklistid', 'in');
        } else if (filterType == 'type') {
            this.adjTable.filter($event.value, 'Txntype', 'in');
        } else if (filterType == 'employee') {
            this.adjTable.filter($event.value, 'Employeelistid', 'in');
        } else if (filterType == 'cc') {
            this.adjTable.filter($event.value, 'Costcenterid', 'in');
        } else if (filterType == 'contract') {
            this.adjTable.filter($event.value, 'Contractdesc', 'in');
        }
    }

    onEditInit($event: { data: ManualAdjustment }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: ManualAdjustment) {
        this.clonedAdjustments[rowData.Txnid] = { ...rowData };
        this.editing = rowData;
        if (this.filterFormGroup.controls['direct'].value != null) {
            const directTxnTypes = this.txntypes.filter(
                x => x.CostType == 'Direct'
            );
            this.txnTypesInTableSelectItem = directTxnTypes.map(x => ({
                value: x.CalcType,
                label: x.CalcDesc
            }));
        } else {
            const indirectTxnTypes = this.txntypes.filter(
                x => x.CostType == 'Indirect'
            );
            this.txnTypesInTableSelectItem = indirectTxnTypes.map(x => ({
                value: x.CalcType,
                label: x.CalcDesc
            }));
        }

        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: ManualAdjustment) {
        rowData = {
            ...rowData,
            Autoburden: this.autoBurden,
            Autocalculate: this.autoCalculate
        };
        this.SaveAdjustment.next(rowData);
        delete this.clonedAdjustments[rowData.Txnid];
        delete this.editing;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: ManualAdjustment) {
        delete this.clonedAdjustments[item.Txnid];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }

    onadjDelete(adj) {
        this.DeleteAdjustment.next(adj);
    }

    buildTable() {
        if (this.addFormGroup.controls['Asofdate'].value == null) {
            this.asOfDateIsRequired = true;
        }
        if (this.addFormGroup.controls['Contracts'].value == null) {
            this.contractIsRequired = true;
        }
        if (this.addFormGroup.controls['Txntypes'].value == null) {
            this.txnTypeIsRequired = true;
        }
        if (this.addFormGroup.controls['Tasks'].value == null) {
            this.taskIsRequired = true;
        }
        if (this.addFormGroup.controls['CC'].value == null) {
            this.ccIsRequired = true;
            this.addFormGroup.controls['CC'].markAsTouched();
        }

        if (this.userGroups && this.userGroups.length > 1) {
            if (
                this.asOfDateValid == true &&
                this.contractValid == true &&
                this.txnTypeValid == true &&
                this.taskValid == true &&
                this.ccValid == true
            ) {
                this.showDialog = false;
                if (this.addFormGroup.controls['Contracts'].value != null) {
                    this.selectedContract = this.contracts.find(
                        x =>
                            x.ContractListID ==
                            this.addFormGroup.controls['Contracts'].value
                    ) as Contract.Contract;
                    const filteredTasks = this.tasks.filter(x =>
                        x.TaskLongName.includes(
                            this.selectedContract.ContractDesc
                        )
                    );
                    this.tasksInTableSelectItem = filteredTasks.map(x => ({
                        value: x.TaskListID,
                        label: x.TaskLongName
                    }));
                }

                // this.showRequiredMessage = false;

                this.AddAdjustments.next({
                    DirectOrIndirect: this.doi,
                    Todayonly: false,
                    Asofdate: this.addFormGroup.controls['Asofdate'].value,
                    Tasks: this.selectedTasks,
                    ServiceItems: this.selectedServiceItems,
                    PayrollItems: this.selectedPayrollItems,
                    DirectReports: this.selectedDirectReports,
                    Txntype: this.addFormGroup.controls['Txntypes'].value,
                    CostCenters: this.selectedCCs,
                    TxnNotes: this.txnNote
                });

                this.selectedTasks = [];
                this.selectedServiceItems = [];
                this.selectedDirectReports = [];
                this.selectedCCs = [];
                this.selectedContracts = [];
                this.txnNote = '';

                this.taskFormGroup.controls['Task'].reset();
                this.typeFormGroup.controls['Type'].reset();
                this.siFormGroup.controls['SI'].reset();
                this.piFormGroup.controls['pi'].reset();
                this.empFormGroup.controls['Emp'].reset();
                this.ccFormGroup.controls['CC'].reset();

                this.addFormGroup.controls['Asofdate'].reset();
                this.addFormGroup.controls['Contracts'].reset();
                this.addFormGroup.controls['Tasks'].reset();
                this.addFormGroup.controls['Txntypes'].reset();
                this.addFormGroup.controls['Items'].reset();
                this.addFormGroup.controls['PayrollItems'].reset();
                this.addFormGroup.controls['DirectReports'].reset();
                this.addFormGroup.controls['CC'].reset();
                this.addFormGroup.controls['note'].reset();

                if (this.siHidden == true) {
                    this.siColumnHidden = true;
                }
                if (this.empHidden == true) {
                    this.empColumnHidden = true;
                }
            } else {
                // this.showRequiredMessage = true;
            }
        } else {
            if (
                this.asOfDateValid == true &&
                this.contractValid == true &&
                this.txnTypeValid == true &&
                this.taskValid == true
            ) {
                this.showDialog = false;
                if (this.addFormGroup.controls['Contracts'].value != null) {
                    this.selectedContract = this.contracts.find(
                        x =>
                            x.ContractListID ==
                            this.addFormGroup.controls['Contracts'].value
                    ) as Contract.Contract;
                    const filteredTasks = this.tasks.filter(x =>
                        x.TaskLongName.includes(
                            this.selectedContract.ContractDesc
                        )
                    );
                    this.tasksInTableSelectItem = filteredTasks.map(x => ({
                        value: x.TaskListID,
                        label: x.TaskLongName
                    }));
                }

                // this.showRequiredMessage = false;

                this.AddAdjustments.next({
                    DirectOrIndirect: this.doi,
                    Todayonly: false,
                    Asofdate: this.addFormGroup.controls['Asofdate'].value,
                    Tasks: this.selectedTasks,
                    ServiceItems: this.selectedServiceItems,
                    PayrollItems: this.selectedPayrollItems,
                    DirectReports: this.selectedDirectReports,
                    Txntype: this.addFormGroup.controls['Txntypes'].value,
                    CostCenters: this.selectedCCs,
                    TxnNotes: this.txnNote
                });

                this.selectedTasks = [];
                this.selectedServiceItems = [];
                this.selectedDirectReports = [];
                this.selectedCCs = [];
                this.selectedContracts = [];
                this.txnNote = '';

                this.taskFormGroup.controls['Task'].reset();
                this.typeFormGroup.controls['Type'].reset();
                this.siFormGroup.controls['SI'].reset();
                this.piFormGroup.controls['pi'].reset();
                this.empFormGroup.controls['Emp'].reset();
                this.ccFormGroup.controls['CC'].reset();

                this.addFormGroup.controls['Asofdate'].reset();
                this.addFormGroup.controls['Contracts'].reset();
                this.addFormGroup.controls['Tasks'].reset();
                this.addFormGroup.controls['Txntypes'].reset();
                this.addFormGroup.controls['Items'].reset();
                this.addFormGroup.controls['PayrollItems'].reset();
                this.addFormGroup.controls['DirectReports'].reset();
                this.addFormGroup.controls['CC'].reset();
                this.addFormGroup.controls['note'].reset();

                if (this.siHidden == true) {
                    this.siColumnHidden = true;
                }
                if (this.empHidden == true) {
                    this.empColumnHidden = true;
                }
            } else {
                // this.showRequiredMessage = true;
            }
        }

        if (this.doi == 'Direct') {
            if (this.filterFormGroup.controls['direct'].value == null) {
                this.filterFormGroup.controls['direct'].patchValue('direct');
            }
        } else {
            if (this.filterFormGroup.controls['indirect'].value == null) {
                this.filterFormGroup.controls['indirect'].patchValue(
                    'indirect'
                );
            }
        }
        if (this.asOfDate <= this.endDate && this.asOfDate >= this.startDate) {
        } else {
            this.filterFormGroup.controls['Range'].patchValue([
                this.startDate,
                this.endDate
            ]);
        }
        this.asOfDate = null;
    }

    clearBuild() {
        this.asOfDate = null;
        this.selectedTasks = [];
        this.selectedServiceItems = [];
        this.selectedDirectReports = [];
        this.selectedContracts = [];
        this.txnNote = '';
        // this.showRequiredMessage = false;
        this.asOfDateIsRequired = false;
        this.contractIsRequired = false;
        this.directReportIsRequired = false;
        this.serviceItemIsRequired = false;
        this.txnTypeIsRequired = false;
        this.ccIsRequired = false;
        this.taskIsRequired = false;
        this.empHidden = false;
        this.siHidden = false;
        this.asOfDateValid = false;
        this.contractValid = false;
        this.taskValid = false;
        this.txnTypeValid = false;
        this.ccValid = false;
        this.serviceItemValid = false;
        this.directReportValid = false;
        this.addFormGroup.controls['Asofdate'].reset();
        this.addFormGroup.controls['Contracts'].reset();
        this.addFormGroup.controls['Tasks'].reset();
        this.addFormGroup.controls['Txntypes'].reset();
        this.addFormGroup.controls['Items'].reset();
        this.addFormGroup.controls['PayrollItems'].reset();
        this.addFormGroup.controls['DirectReports'].reset();
        this.addFormGroup.controls['CC'].reset();
        this.addFormGroup.controls['note'].reset();
        if (this.doi == 'Direct') {
            this.tasksSelectItem = this.tasks
                .filter(f => f.ContractType != 'LOC')
                .map(x => ({
                    value: x.TaskListID,
                    label: x.TaskLongName
                }));
            this.tasksInTableSelectItem = this.tasks
                .filter(f => f.ContractType != 'LOC')
                .map(x => ({
                    value: x.TaskListID,
                    label: x.TaskLongName
                }));
            this.txnTypesInTableSelectItem = this.txntypes
                .filter(f => f.CalcType == 'Direct')
                .map(x => ({
                    value: x.CalcType,
                    label: x.CalcDesc
                }));
        } else {
            this.tasksSelectItem = this.tasks
                .filter(f => f.ContractType == 'LOC')
                .map(x => ({
                    value: x.TaskListID,
                    label: x.TaskLongName
                }));
            this.tasksInTableSelectItem = this.tasks
                .filter(f => f.ContractType == 'LOC')
                .map(x => ({
                    value: x.TaskListID,
                    label: x.TaskLongName
                }));
            this.txnTypesInTableSelectItem = this.txntypes
                .filter(f => f.CalcType == 'Indirect')
                .map(x => ({
                    value: x.CalcType,
                    label: x.CalcDesc
                }));
        }
    }

    onSelectedColumnsChange($event) {
        if ($event.value) {
            if ($event.itemValue) {
                if ($event.itemValue.header) {
                    if ($event.itemValue.header == 'Item') {
                        if (this.SIColumnHidden == true) {
                            this.SIColumnHidden = false;
                        } else {
                            this.SIColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Person') {
                        if (this.EmpColumnHidden == true) {
                            this.EmpColumnHidden = false;
                        } else {
                            this.EmpColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Payroll Item') {
                        if (this.PIColumnHidden == true) {
                            this.PIColumnHidden = false;
                        } else {
                            this.PIColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Cost Center') {
                        if (this.CCColumnHidden == true) {
                            this.CCColumnHidden = false;
                        } else {
                            this.CCColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Billable Status') {
                        if (this.BillableColumnHidden == true) {
                            this.BillableColumnHidden = false;
                        } else {
                            this.BillableColumnHidden = true;
                        }
                    }
                    this.header = $event.itemValue.header;
                }
                this.length = $event.value.length;
            } else {
                this.length = $event.value.length;
                if (this.length > 0) {
                    this.EmpColumnHidden = false;
                    this.SIColumnHidden = false;
                    this.PIColumnHidden = false;
                    this.CCColumnHidden = false;
                    this.BillableColumnHidden = false;
                } else {
                    if (this.EmpColumnHidden == true) {
                        this.EmpColumnHidden = false;
                    } else {
                        this.EmpColumnHidden = true;
                    }
                    if (this.SIColumnHidden == true) {
                        this.SIColumnHidden = false;
                    } else {
                        this.SIColumnHidden = true;
                    }
                    if (this.PIColumnHidden == true) {
                        this.PIColumnHidden = false;
                    } else {
                        this.PIColumnHidden = true;
                    }
                    if (this.CCColumnHidden == true) {
                        this.CCColumnHidden = false;
                    } else {
                        this.CCColumnHidden = true;
                    }
                    if (this.BillableColumnHidden == true) {
                        this.BillableColumnHidden = false;
                    } else {
                        this.BillableColumnHidden = true;
                    }
                    this.length = 0;
                }
            }
            this.colspan = this.length + 1;
        }
    }
}

export interface Item {
    IListID: string;
    Item: string;
    IsActive: boolean;
}
